const refundRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
}
const externalLinks = {
  karisma: 'https://www.karismahotels.com/es/nickelodeon-hotels-resorts/riviera-maya/experiencias/aqua-nick'
}

export {
  refundRequestStatus,
  externalLinks
}
